import { render } from "./protectionCartModal.vue?vue&type=template&id=6041cc54"
import script from "./protectionCartModal.vue?vue&type=script&lang=js"
export * from "./protectionCartModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__